<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Feedback Attendance</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Academic Year"
            outlined
            @change="getStd()"
            @click="putnull"
          />
        </v-col>
        <v-col sm="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_std_data"
            return-object
            :items="std_div_list"
            item-text="std"
            label="Standard"
            outlined
            @change="getDiv"
            @click="putnull"
          />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="div"
            return-object
            :items="div_list"
            item-text="div_name"
            label="Division"
            outlined
            @click="putnull"
          />
        </v-col>
        <v-col sm="2" v-if="sel_ay_data && sel_std_data && div && status_list">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="selected_status"
            return-object
            :items="status_list"
            item-text="name"
            label="Status"
            outlined
            @click="putnull"
            @change="get_feedback_version"
          />
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col
          sm="2"
          v-if="sel_ay_data && sel_std_data && selected_status && version_list"
        >
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="selected_feedback_version"
            return-object
            :items="version_list"
            item-text="feedback_version_name"
            item-id="feedback_version_id"
            label="Feedback Version"
            outlined
            @click="putnull"
            @change="get_feedback_version"
          />
        </v-col>
        <div class='center'
          v-if="sel_ay_data && sel_std_data && selected_status && version_list"
          >*Academic Year::Feedback Type::Feedback Number
        </div>
      </v-row>
      <v-row justify="center" dense>
      </v-row>
      <v-row justify="center" dense>
        <v-col
          sm="2"
          v-if="
            sel_ay_data &&
            sel_std_data &&
            div &&
            selected_status &&
            selected_feedback_version
          "
        >
          <v-btn
            class="mt-6 button"
            @click="fetch_feedback_data()"
            :loading="fetch_loader"
            >Fetch</v-btn
          >
        </v-col>
      </v-row>
      <span v-if="mainList != '' && mainList != null">
        <v-card>
          <v-card-title>
            <download-excel
              class="mr-2 pb-3 pt-2"
              :data="mainList"
              :fields="table_fields"
              worksheet="Student_Feedback_List"
              name="StudentFeedbackList.xls"
            >
              <v-btn color="success" outlined rounded>
                <v-icon dark>mdi-file-excel</v-icon> Export
              </v-btn>
            </download-excel>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-if="mainList.length > 0"
            :headers="headers1"
            :items="mainList"
            :search="search"
            class="elevation-1"
            v-model="selected"
            item-key="ld_id"
          >
          </v-data-table>
        </v-card>
      </span>
      <!-- <v-row class="justify-center">
        <v-btn
          v-if="mainList != '' && mainList != null"
          class="button"
          :loading="fetch_loader"
          @click="nextpage"
          >Compose Mail / SMS <v-icon>mdi-email-plus</v-icon></v-btn
        >
      </v-row> -->
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      overlay: false,
      faildailog: false,
      failsmsdailog: false,
      failed_mail_student_list: [],
      failed_sms_student_list: [],
      smsbody: "",
      emailbody: "",
      emailsubject: "",
      openemail: false,
      opensms: false,
      opencomposewindow: false,
      fetch_loader: false,
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      mainList: [],
      selected: [],
      total_students: [],
      selected_status: "",
      status_list: [{ name: "Present" }, { name: "Absent" }, { name: "All" }],
      version_list: [],
      selected_feedback_version: "",
      headers1: [
        {
          text: "Sr. No.",
          value: "sr_no",
        },
        {
          text: "Roll No",
          align: "center",
          value: "roll_no",
        },
        {
          text: "Student Name",
          align: "center",
          value: "student_name",
        },
        {
          text: "Gr No.",
          align: "center",
          value: "gr_no",
        },
        {
          text: "Status",
          align: "center",
          value: "status",
        },
      ],
      table_fields: {
        "Roll No.": "roll_no",
        "Student Name": "student_name",
        "GR No.": "gr_no",
        Status: "status",
      },
    };
  },
  methods: {
    get_feedback_version() {
      axios
        .post("/Feedback/get_feedback_versions")
        .then((res) => {
          if (res.data.feedback_version_list != null) {
            this.version_list = res.data.feedback_version_list;
          } else {
            this.showSnackbar("#b71c1c", "Feedback version not present!"); // show snackbar
            return;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    putnull() {
      this.mainList = [];
    },
    fetch_feedback_data() {
      this.fetch_loader = true;
      let ay;
      let div = this.div.div_id;
      let standard = this.sel_std_data.std_id;

      if (this.sel_ay_data.ay_id) {
        ay = this.sel_ay_data.ay_id;
      } else if (this.sel_ay_data.id) {
        ay = this.sel_ay_data.id;
      }
      if (this.div.div_id) {
        div = this.div.div_id;
      } else {
        div = this.div;
      }

      const data = {
        ay: ay,
        division: div,
        standard: standard,
        status: this.selected_status.name,
        feedback_version_id: this.selected_feedback_version.feedback_version_id,
      };
      axios
        .post("/Feedback/get_feedback_attendance", data)
        .then((res) => {
          if (res.data.feedback_data.length != 0) {
            this.mainList = res.data.feedback_data;
            this.fetch_loader = false;
          } else {
            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
        })
        .finally(() => {
          ay = null;
          this.fetch_loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>

<style scoped>
.center {
  font-size: 14px; font-style: italic; color: rgb(75, 75, 189);
 margin-top: 35px;
}
</style>